export function fn1(event, res) {
    console.log(this)
    console.log(event)
    console.log(res)
}

export function fn2(event, res) {
    console.log(this)
    console.log(event)
    console.log(res)
}